export default __webpack_public_path__ + "fonts/ai_4.f0d8ea1bb4626fc3cb80532ca924193d.png";